module.exports = "/_next/static/images/quote-bg-e42ff54eb3e2c7e5a7b819d1125c734d.png.webp";